function stringifyArray(str) {
  if (!str) return undefined;
  if (typeof str === 'string' || str instanceof String) {
    return str.replace(/[^0-9]/g, '');
  }
  return str;
}
export default stringifyArray;
